import React from 'react'
import {Link} from 'react-router-dom'
import OrangeCircle from '../../assets/Images/Oval.svg'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

const Sidebar = ({isOpen, toggle}) => {
    let user = JSON.parse(sessionStorage.getItem('user'))
    let history = useHistory();

    const openProfile = () => {
        toggle(false)
        // history.push("/profile")
    }
    const useProfilePictureImg = () => {
        //let user = JSON.parse(sessionStorage.getItem('user'))
        console.log("getting profile picture for sidebar")
        if(user != null && user["profilepicture"] != undefined) {
            //console.log("We got the profile pic", user.profilepicture)
            return `https://polar-castle-07148.herokuapp.com/api/user/images/profileavatars/${user.id}/${user.profilepicture}`
        }
        else{
            return `https://polar-castle-07148.herokuapp.com/api/user/images/profileavatars/noprofile/profilepicture.jpg`
        }
    }
    return (
        <>
            <div className={`fixed z-50 w-full sm:w-82 bg-linear-button-home  h-full b grid top-0 right-0 transform transition ease-in-out duration-700 ${isOpen ? '-translate-x-0' : 'translate-x-full'}`}>
                <div className="absolute top-5 right-6 bg-transparent border-transparent text-3xl cursor-pointer outline-none" onClick={()=> toggle(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" viewBox="0 0 20 20" fill="#FFFFFF">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="grid grid-cols-sidebarcolgrid grid-rows-sidebarrowgridM md:grid-rows-sidebarrowgridM text-center ">
                    <Link className="flex items-center justify-center text-2xl no-underline text-white  transition ease-in-out duration-150 hover:text-black"  to="/" onClick={()=> toggle(false)}>
                        Home
                    </Link>
                    <Link className="flex items-center justify-center text-2xl no-underline text-white  transition ease-in-out duration-150 hover:text-black" to="/social" onClick={()=> toggle(false)}>
                        Social Feed
                    </Link>
                    <Link className="flex items-center justify-center text-2xl no-underline text-white  transition ease-in-out duration-150 hover:text-black" to="/tutorial" onClick={()=> toggle(false)}>
                        Tutorial
                    </Link>
                    <a className="flex items-center justify-center text-2xl no-underline text-white  transition ease-in-out duration-150 hover:text-black" onClick={openProfile} href="/profile">
                        Your Wardrobe
                    </a>
                    <Link className="flex items-center justify-center text-2xl no-underline text-white  transition ease-in-out duration-150 hover:text-black" to="/Login" onClick={()=> toggle(true)}>
                        {user!=null ? "Logout" : "Login"}
                    </Link>
                </div>
                <div className="flex justify-center mt-10 items-center ">
                    <div className="max-h-46 w-36 b flex justify-center rounded-xl border">
                        <img
                            className="rounded-full h-36 w-full object-cover "
                            src={useProfilePictureImg()}
                            alt={"Well hello"}
                        />
                    </div>
                    <a className="cursor-pointer text-xl py-4 px-10 text-white outline-none border-none transition ease-in-out whitespace-nowrap   hover:text-black" onClick={openProfile} href="/profile">
                        Your Profile
                    </a>
                </div>
            </div>
        </>
    )
}

export default Sidebar